var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutboundCallButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#4CAF50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.96 28.042l-.691.375a3.043 3.043 0 01-3.59-.523l-5.576-5.576a3.05 3.05 0 01-.522-3.596l.375-.686a4.068 4.068 0 00.448-2.535 4.018 4.018 0 00-1.15-2.308A4.052 4.052 0 0016.364 12a4.064 4.064 0 00-2.893 1.193l-.269.275c-1.425 1.426-1.59 3.881-.464 6.923 1.06 2.904 3.199 6.051 6.008 8.86C23.027 33.535 27.796 36 31.217 36c1.351 0 2.497-.386 3.31-1.199l.275-.274A4.087 4.087 0 0036 31.633a4.148 4.148 0 00-1.198-2.888 4.114 4.114 0 00-4.842-.703z",
    fill: "#fff"
  })));
}

export default SvgOutboundCallButton;